export default "__VITE_ASSET__CnFRud4N__"